import { Moment } from 'moment'

// import { AppDispatch } from '../../../App/Store'
import Client from '../Client/Client'
import { IPerformanceStats } from '../Client/IPerformanceStats'

import {
  GET_PERFORMANCE_STATS_REQUEST,
  GET_PERFORMANCE_STATS_SUCCESS,
} from './ActionTypes'

export const getPerformanceStats = (from: Moment, to: Moment) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: GET_PERFORMANCE_STATS_REQUEST,
    })

    return Client.getPerformanceStats(from, to).then(
      (performanceStatsRequest: IPerformanceStats[]) => {
        dispatch(getPersonPerformanceStatsSuccess(performanceStatsRequest))
      },
    )
  }
}

export const getPersonPerformanceStatsSuccess = (
  performanceReports: IPerformanceStats[],
) => {
  return {
    type: GET_PERFORMANCE_STATS_SUCCESS,
    payload: {
      performanceReports,
    },
  }
}
